export const sx = {
    '.lightTheme &:': {
        borderRight: '1px solid #5f5f5f1a',

    },
    '.lightTheme &:last-child': {
        borderRight: '1px solid transparent',
    },
    '.lightTheme thead &': {
        backgroundColor: '#fff',
        fontWeight:'600'
    },
    '.lightTheme .MuiTableRow-root:last-child &':{
        border:'1px solid transparent'
    },
    '.lightTheme &.MuiTableCell-head':{
        // backgroundColor: '#f4f4f4',
        color:'#5f5f5f',
        fontWeight: 600,
    }
}